import UsersRoles from './UsersRoles';

export const getHomePageRoute = (userRole: string) => {

    if (userRole === UsersRoles.superUser) {
        return '/SuperUser';
    } else if (userRole === UsersRoles.admin) {
        return '/Admin';
    } else if (userRole === UsersRoles.agronomist) {
        return '/Agronomist';
    }

    return '/Home';
}



// WEBPACK FOOTER //
// ./src/infrastructure/HomePageRoute.ts